import PropTypes from "prop-types";

import ProfileHeader from "pages-sections/dashboard/ProfileHeader.js";

import React from "react";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

export function TeamMember(props) {
  const { member } = props;

  return (
    member.userDetails.linkedAthlete && (
      <GridContainer spacing={2} sx={{ mb: 2 }}>
        <GridItem xs>
          <ProfileHeader
            user={member.userDetails.linkedAthlete}
            isLoggedInDashboard={false}
            loading={false}
          />
        </GridItem>
      </GridContainer>
    )
  );
}

TeamMember.propTypes = {
  member: PropTypes.shape({
    avatar: PropTypes.shape({
      url: PropTypes.string,
    }),
    description: PropTypes.string,
    id: PropTypes.string,
    name: PropTypes.string,
    position: PropTypes.string,
    userDetails: PropTypes.shape({}),
  }),
  showRole: PropTypes.bool,
};
